import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import PcpCard from "./components/pcp-card";
import NoDataFallback from "@/components/ui/fallback-nodata";
import type { IDialogBox } from "@/pages/components/header";
import { usePcpInfo } from "@/hooks/use-pcpInfo";
import type { IPcpInfoResponse } from "@/hooks/use-pcpInfo";

const MyPcp: React.FC<IDialogBox> = ({
  dialogOpen,
  setDialogOpen,
  logDialogName,
  logTrigger,
}) => {
  type PcpInfoCard = IPcpInfoResponse["results"][number];
  // const userInfo = useUserInfo();

  const pcpInfoQuery = usePcpInfo();

  // if (pcpInfoQuery.isLoading) {
  //   return <LoadingIndiator />;
  // }
  if (pcpInfoQuery.isError) {
    return <div>Error: {pcpInfoQuery.error.message}</div>;
  }

  // console.log(pcpInfoQuery.data);

  return (
    <Dialog
      open={dialogOpen}
      onOpenChange={(open) => {
        setDialogOpen(open);
      }}
      logDialogName={logDialogName}
      logTrigger={logTrigger}
    >
      <DialogContent className="sm:max-w-[500px]" logDialogName={logDialogName}>
        <div defaultValue="notifications" className="rounded-2xl bg-white p-6">
          <div className="mx-auto max-w-4xl">
            <div className="add-class">
              <div className="rounded bg-gray-200">
                <div className="space-y-2 bg-white px-4">
                  <Card className="border-none shadow-none">
                    <CardHeader className="border-b border-gray-300 p-2 pb-6 text-center">
                      {/*
                        4.1.2 Name, Role, Value — A. The dialog had no accessible name, so
                        a screen reader announced only "dialog" when it opened. Rather than
                        add a hidden duplicate, the heading that is already on screen is
                        promoted to DialogTitle — it names the dialog and remains the
                        visible title. (CardTitle also renders a plain <div>, so this was
                        not a heading at all before — 1.3.1 Info and Relationships — A.)
                      */}
                      <DialogTitle className="font-semibold leading-none tracking-tight">
                        Primary Care Provider
                      </DialogTitle>
                      <div>(Based on past visits & locations)</div>
                    </CardHeader>
                    <CardContent className="mt-6 grid w-full gap-y-4 p-0">
                      <div className="flex max-h-[500px] flex-col gap-3 overflow-y-auto pb-4 pr-2">
                        {pcpInfoQuery.data?.results &&
                        pcpInfoQuery.data?.results?.length > 0 ? (
                          pcpInfoQuery.data?.results.map(
                            (pcpInfo: PcpInfoCard) => (
                              <PcpCard
                                key={pcpInfo?.memberId}
                                pcpName={pcpInfo?.name}
                                firstName={pcpInfo?.firstName}
                                lastName={pcpInfo?.lastName}
                                visitDate={pcpInfo?.visitDate}
                              />
                            ),
                          )
                        ) : (
                          <NoDataFallback title="PCP" />
                        )}
                      </div>
                    </CardContent>
                  </Card>
                </div>
              </div>
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default MyPcp;
